// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"cb9cfe41","459":"ddf30afc","494":"9d1e6107","618":"eb6dcca8"}[chunkId] + ".chunk.css";
};